import { useEffect, useState, useCallback, useRef } from "react";
import { Link, useNavigate, useParams } from "react-router-dom";
import { useTranslation } from "react-i18next";
import { FormControl, Tab, Grid, Table } from "@/comn/components";
import { comnEnvs, comnUtils } from "@/comn/utils";
import { Page, Group, Layout, Button, ExcelUpload } from "@/comn/components";
import { lpcoEnvs, lpcoUtils } from "@/tz/go/egaz/osci/lpco/comn";
import {
    useForm,
    useFetch,
    useModal,
    useStore,
    useToast,
    usePopup,
    useTab,
    useGrid,
    useResource,
    usePage,
    useAuth,
} from "@/comn/hooks";
import {
    BASE,
    URLS,
    APIS,
    SF_SCHEMA_BKNG_SRCH_FORM,
    SG_GRID_INSC_BKNG_LIST,
} from "@/tz/go/egaz/osci/lpco/jntinsc/services/OsciJntinscService";
import { MASK } from "@/tz/go/egaz/osci/lpco/comn/LpcoConstants";
/*
 * List Joint Inspection
 * !== 합동검사 예약 목록 화면 ==!
 */
export const OSCI0301001Q = (props: any) => {
    /**
     * Page Unique identifier !== 화면 고유 식별자 ==!
     * Page Title !== 페이지 타이틀 ==!
     */
    const { pgeUid, menuId } = usePage({
        auth: ["auth_osci0011"],
    });
    const { t } = useTranslation(); // Translation Hook !== 언어 변화 Hook ==!
    const navigate = useNavigate(); // Navigate Hook !== 화면 이동 Hook ==!
    const modal = useModal(); // Modal Window Hook !== Modal 창 Hook ==!
    const { pgeStore, setStore } = useStore({ pgeUid: pgeUid }); // Page Store Hook !== 화면 데이터 저장 Hook ==!
    const toast = useToast(); // Toast Message Hook !== Toast 메세지 표시 Hook ==!
    const auth = useAuth(); // Login , User Information Hook !== 로그인, 유저정보 Hook ==!

    let menuTp: any = "";
    let errmsg: any;

    /*
     * Joint Inspection Search Form
     * !== 합동검사 조회용 Form 정의 ==!
     */
    const form = {
        inscSrchForm: useForm({
            defaultSchema: SF_SCHEMA_BKNG_SRCH_FORM,
            defaultValues: {
                ...(pgeStore?.form || {}),
                srchDtStrt: comnUtils.getDate({ m: -1 }),
                srchDtEnd: comnUtils.getDate(),
            },
        }),
    };

    /*
     * Joint Inspection Target List Grid
     * !== 합동검사 대상 목록 그리드 정의 ==!
     */
    const grid = {
        inscBkngList: useGrid({
            defaultSchema: SG_GRID_INSC_BKNG_LIST,
            page: pgeStore?.page,
            size: pgeStore?.size,
        }),
    };

    const fetch = {
        // Search the Joint Inspection Target list. !== 합동검사 대상 목록을 조회한다. ==!
        getJntInscBkngList: useFetch({
            api: (page = grid.inscBkngList.page) => {
                return APIS.getJntInscBkngList(
                    { ...form.inscSrchForm.getValues(), srchOrgCd: auth.get("orgCd"), menuTp: "VRFN" },
                    page,
                    grid.inscBkngList.size,
                );
            },
            enabled: comnUtils.isEmpty(form.inscSrchForm.errors) && form.inscSrchForm.isSubmitted,
            key: [grid.inscBkngList.page, grid.inscBkngList.size],
            onSuccess: (data) => {
                setStore(pgeUid, {
                    form: form.inscSrchForm.getValues(),
                    menuTp: "VRFN",
                    page: grid.inscBkngList.page,
                    size: grid.inscBkngList.size,
                });
            },
            onError: (error) => {
                errmsg =
                    error.response?.data.errorCode == -1
                        ? "msg.osc.00015"
                        : error.response?.data.errorMessage || "msg.osc.00015";
                modal.openModal({
                    content: errmsg,
                });
            },
            showToast: true,
        }),
        updateReceived: useFetch({
            api: (tansadNo, prcsStatCd) => {
                return APIS.updateReceived(tansadNo, prcsStatCd);
            },
            onSuccess: (data, param) => {
                navigate(URLS.osci0301002s + "/" + param[0], { state: { menuTp: "VRFN", tansadNo: param[0] } });
            },
            onError: (err) => {
                modal.openModal({ content: err.response.data.errorMessage });
            },
            showToast: false,
        }),
    };

    /*
     * Joint Inspection Event Handler
     * !== 합동 검사 이벤트 핸들러 정의 ==!
     */
    const handler = {
        // setInit: async () => {
        //     handler.getJntInspInfoLst();
        // },
        // Search the Joint Inspection Booked list. !== 합동검사 예약 목록을 조회 ==!
        getJntInspInfoLst: (page: number = 0) => {
            form.inscSrchForm.handleSubmit(
                (data) => {
                    grid.inscBkngList.setPage(page);
                    fetch.getJntInscBkngList.fetch(page);
                },
                (data) => {
                    toast.showToast({ type: "warning", content: "msg.osc.00003" });
                },
            )();
        },
        ketOnPaste: (e: any) => {
            const data = e.clipboardData.getData("Text").replace(/[^\w]/g, "");
            if (data.length >= 9) {
                if (data.substring(0, 9) != auth.get("tin")) {
                    alert("The copied Tin number is incorrect.");
                    return;
                }
            }
            if (data.length <= 9) {
                form.inscSrchForm.setValue("reffTin", data);
            } else if (data.length > 9 && data.length <= 11) {
                form.inscSrchForm.setValue("reffTin", data.substring(0, 9));
                form.inscSrchForm.setValue("reffYy", data.substring(9, 11));
            } else if (data.length > 11) {
                form.inscSrchForm.setValue("reffTin", data.substring(0, 9));
                form.inscSrchForm.setValue("reffYy", data.substring(9, 11));
                form.inscSrchForm.setValue("reffSrno", data.substring(11, 18));
            }
        },
        ketOnTansadPaste: (e: any) => {
            const data = e.clipboardData.getData("Text").replace(/[^\w]/g, "");
            if (data.length <= 4) {
                form.inscSrchForm.setValue("cstmOfceCd", data);
            } else if (data.length > 4 && data.length <= 6) {
                form.inscSrchForm.setValue("cstmOfceCd", data.substring(0, 4));
                form.inscSrchForm.setValue("tansadYy", data.substring(4, 6));
            } else if (data.length > 6) {
                form.inscSrchForm.setValue("cstmOfceCd", data.substring(0, 4));
                form.inscSrchForm.setValue("tansadYy", data.substring(4, 6));
                form.inscSrchForm.setValue("tansadSrno", data.substring(6, 13));
            }
        },
        updateReceived: async (tansadNo: any, prcsStatCd: any) => {
            fetch.updateReceived.fetch(tansadNo, prcsStatCd);
        },
    };

    const render = {
        grid_inscBkngList: {
            cell: {
                tansadNo: (props: any) => {
                    const { binding, rowValues, value } = props;
                    const param = {
                        menuTp: "VRFN",
                        tansadNo: rowValues.tansadNo,
                        asnmtCfrmDtm: rowValues.asnmtCfrmDtm,
                        prcsStatCd: rowValues.prcsStatCd,
                    };
                    const tansadNo = comnUtils.getFormattedValue(rowValues.tansadNo, {
                        type: "text",
                        mask: MASK.TANSAD_NO,
                    });
                    return (
                        <Layout direction="col" gap={1}>
                            <Link to={`${URLS.osci0301002s}/${rowValues.tansadNo}`} state={param}>
                                {`${tansadNo}`}
                            </Link>
                        </Layout>
                    );
                },
                reffNo: (props: any) => {
                    const { binding, rowValues, value } = props;
                    // Pre-verification bookings have no TANSAD yet, so show that instead of a Reference No.
                    // !== 사전검증 예약은 아직 TANSAD가 없어 Reference No. 대신 사전검증임을 표시한다 ==!
                    if (!rowValues.reffTin) return "Pre-verification inspection";
                    return `${rowValues.reffTin}-${rowValues.reffYy}-${rowValues.reffSrno}`;
                },
                prcsStatCd: (props: any) => {
                    const { control, rowValues, value } = props;
                    // let bVisible = rowValues.asinDtm == null;
                    let usrVisible = rowValues.asnmtOfcrId == auth.get("usrId");
                    const prcsStatCd = rowValues.prcsStatCd;

                    if (usrVisible && prcsStatCd === "A") {
                        return (
                            <Button
                                type="button"
                                color="success"
                                onClick={() => {
                                    handler.updateReceived(rowValues.tansadNo, rowValues.prcsStatCd);
                                }}
                            >
                                {t("L_RCVE_1")}
                            </Button>
                        );
                    } else {
                        return control;
                    }
                },
            },
        },
    };

    useEffect(() => {
        pgeStore?.form && (form.inscSrchForm.setValues(pgeStore.form), handler.getJntInspInfoLst(pgeStore?.page));
    }, []);

    return (
        <Page>
            {/* <form> */}
            <Group>
                <Group.Body>
                    <Group.Section>
                        <Group.Row>
                            <Group.Label {...form.inscSrchForm.schema.tansadNo}></Group.Label>
                            <Group.Field size={4}>
                                <Group.Control
                                    {...form.inscSrchForm.schema.cstmOfceCd}
                                    onPaste={(e: any) => {
                                        e.preventDefault();
                                        handler.ketOnTansadPaste(e);
                                    }}
                                />
                                <Group.Any>-</Group.Any>
                                <Group.Control {...form.inscSrchForm.schema.tansadYy} />
                                <Group.Any>-</Group.Any>
                                <Group.Control {...form.inscSrchForm.schema.tansadSrno} />
                            </Group.Field>
                            <Group.Label {...form.inscSrchForm.schema.reffNo}></Group.Label>
                            <Group.Field size={10}>
                                <Group.Control
                                    {...form.inscSrchForm.schema.reffTin}
                                    onPaste={(e: any) => {
                                        e.preventDefault();
                                        handler.ketOnPaste(e);
                                    }}
                                />
                                <Group.Any>-</Group.Any>
                                <Group.Control {...form.inscSrchForm.schema.reffYy} />
                                <Group.Any>-</Group.Any>
                                <Group.Control {...form.inscSrchForm.schema.reffSrno} />
                            </Group.Field>
                        </Group.Row>
                        <Group.Row>
                            <Group.Control {...form.inscSrchForm.schema.srchDt} rangeButton={2} />
                            <Group.Control {...form.inscSrchForm.schema.srchStatCd} />
                        </Group.Row>
                        <Group.Row>
                            <Group.Control {...form.inscSrchForm.schema.ucrNo} />
                        </Group.Row>
                    </Group.Section>
                    <Layout direction="row">
                        <Layout.Left>
                            <Button
                                role="reset"
                                onClick={() => {
                                    form.inscSrchForm.clearValues();
                                    form.inscSrchForm.setValues({
                                        cstmOfceCd: "",
                                        tansadYy: "",
                                        tansadSrno: "",
                                        reffTin: "",
                                        reffYy: "",
                                        reffSrno: "",
                                        srchStatCd: "",
                                        ucrNo: "",
                                        srchDtStrt: comnUtils.getDate({ m: -1 }),
                                        srchDtEnd: comnUtils.getDate(),
                                    });
                                }}
                            ></Button>
                        </Layout.Left>
                        <Layout.Right>
                            <Button
                                role="search"
                                onClick={() => {
                                    handler.getJntInspInfoLst();
                                }}
                            ></Button>
                        </Layout.Right>
                    </Layout>
                </Group.Body>
            </Group>

            <Group>
                <Group.Body>
                    <Layout>
                        <Button
                            role="excelDown"
                            onClick={() => {
                                grid.inscBkngList.exportExcel({
                                    excelName: "Inspection booking list",
                                    sheetName: "Inspection booking list ",
                                });
                            }}
                        ></Button>
                    </Layout>
                    <Group.Section>
                        <Grid
                            {...grid.inscBkngList.grid}
                            data={fetch.getJntInscBkngList.data?.jntInscBkngList}
                            render={render.grid_inscBkngList}
                        />
                    </Group.Section>
                </Group.Body>
            </Group>
        </Page>
    );
};
